// extracted by mini-css-extract-plugin
export default {"header":"InfoBox_header__ZtRfw font-sm-regular","header__header":"InfoBox_header__header__orgFS","body":"InfoBox_body__ddo+N"};